import { AuthorizationActionTypes } from './types';
import { setUserAuthData, setUserLoginStatus } from '../../helpers/authorization';
import { notifyError, notifySuccess } from '../../helpers/notifications';

export const actions = {
    async [AuthorizationActionTypes.Login](context, { email, password }) {
        return new Promise((resolve, reject) => {
            this.$api.login.post({
                body: { email, password },
            }).then(({data}) => {
                if (!data.error_message) {
                    setUserAuthData({ data: data.data })
                    setUserLoginStatus()

                    notifySuccess({ title: data.message })

                    window.open('/admin', '_self')

                    resolve({data})
                } else {
                    resolve(data)
                }
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    async [AuthorizationActionTypes.AdminLogin](context, { email, password }) {
        return new Promise((resolve, reject) => {
            this.$api.adminLogin.post({
                body: { email, password },
            }).then(response => {
                if (response) {
                    if (!response.data.error_message) {
                        setUserAuthData({ data: response.data.data })
                        setUserLoginStatus()
    
                        notifySuccess({ title: response.data.message })
    
                        window.open('/admin', '_self')
    
                        resolve(response)
                    } else {
                        notifyError({ title: response.data.error_message, errors: response.data.errors })
                        resolve(response)
                    }
                }
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    async [AuthorizationActionTypes.RecoverPassword](context, { email }) {
        const { data } = await this.$api.passwordRecovery.recover({ email })
        return data
    },
    async [AuthorizationActionTypes.Logout]() {
        return new Promise((resolve, reject) => {
            this.$api.logout.post()
                .then(({ data }) => {
                    if (data && !data.error_message) {
                        notifySuccess({ title: data.message })
                    } else if (data && data.error_message) {
                        notifyError({ title: data.error_message, errors: data.errors })
                    }
                    resolve(data)
                })
                .catch(error => {
                    reject(error)
                })
            })
    },
    async [AuthorizationActionTypes.PingAuth]() {
        try {
            const { data } = await this.$api.PingAuth.get()
            
            if (data.error_message) {
                notifyError({ title: data.error_message, errors: data.errors })  
            }
        } catch (error) {
            console.log('---error', error)
        }            
    },
    async [AuthorizationActionTypes.PingAccess]() {
        try {
            const { data } = await this.$api.pingAccess.get()
            
            if (data.error_message) {
                notifyError({ title: data.error_message, errors: data.errors })  
            }
        } catch (error) {
            console.log('---error', error)
        }            
    },
}